var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoatFront = function SvgBoatFront(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.193 62.511"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.1 62.512c0-7.253 26.6-6.116 26.6-28.446L27.1 21.692.5 34.066c0 22.33 26.6 21.193 26.6 28.446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m45.694 22.729-1.262-9.063a5.29 5.29 0 0 0-3.947-4.4L27.096 5.904v5.974M8.498 22.729l1.262-9.062a5.29 5.29 0 0 1 3.947-4.4l13.389-3.363v5.974"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m34.554 7.778-.5-3.6L27.098.5l-6.955 3.679-.5 3.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.855 54.71h2.973v7.801h-2.973zM12.365 54.71h2.973v7.801h-2.973zM27.1 14.076.5 26.45v4.931l26.6-12.374L53.7 31.38v-4.93Z"
  })));
};
export default SvgBoatFront;